import config from '@/config'
import { requests } from '.'

export const PaymentService = {
  getCurrencyDetails: () =>
    requests(config.PAYMENTS_SERVICE_URL).get(`/currency`),

  fetchPaymentSettings: (locationId: string) =>
    requests(config.PAYMENTS_SERVICE_URL).get(
      `/payment-settings?altId=${locationId}&altType=location`
    ),
}
